<template>
  <BgImageLayout title="Workflow Settings" :page="__guide.workflowSettings" icon-color="white">
    <q-card class="bg-white progress-status-wrapper no-border-radius">
      <q-card-section class="progress-status">
        <ProgressBar class="fields">
          <ProgressBarCategory
            v-for="(category, key) in categories"
            :key="key"
            :category-name="category.name"
            :has-arrow="category.hasArrow"
            class="progress-bar-settings__category"
          >
            <SingleTask v-for="(task, index) of category.tasks" :key="`{task.name}_${index}`" :task="task" />
          </ProgressBarCategory>
        </ProgressBar>
      </q-card-section>
    </q-card>
  </BgImageLayout>
</template>

<script>
import { categories } from './categories'
// Components
import ProgressBar from './components/ProgressBar'
import ProgressBarCategory from './components/ProgressBarCategory'
import SingleTask from './components/SingleTask'

export default {
  components: {
    ProgressBar,
    ProgressBarCategory,
    SingleTask
  },

  created() {
    this.categories = categories
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/stylus/custom-variables'

.progress-status-wrapper {
  height 305px
  .progress-status {
    padding 20px
    width 100%
    height 100%
    display flex
    align-items center

    .fields {
      width 100%
      display grid
      grid-template-columns 1fr 1fr 1fr 1fr 1fr
    }
  }
}

>>> .lm-progress-task__count {
  padding $baseline * 1.5 0
}
</style>
